import React, { useState, useEffect, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { useAtom } from "jotai";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TextField,
  Button,
  IconButton,
  Tooltip,
} from "@mui/material";
import { FaEye, FaTrash, FaPlus, FaSearch } from "react-icons/fa";
import axios from "axios";
import toast from "react-hot-toast";
import { confirmAlert } from "react-confirm-alert";
import dayjs from "dayjs";

import Modal from "../../../components/Modal/Modal";
import ErrorBoundaryRoutes from "../../../components/shared/ErrorBoundaryRoutes";
import { gbState } from "../../../components/shared/GlobalState";

import SponsorView from "./SponsorView";
import placeholderImage from "../../../images/placeholder.png";

const SponsorsListChild = () => {
  let navigate = useNavigate();
  const [showModal, setShowModal] = useState(false);
  const [addShowModal, setAddShowModal] = useState(false);

  const [currentRecord, setCurrentRecord] = useState({});
  const [data, setData] = useState([]);
  const [{ errorLogApi, user }] = useAtom(gbState);
  const toggleModal = () => {
    setShowModal(!showModal);
  };
  const toggleAddModal = () => {
    // setAddShowModal(!addShowModal);
    navigate("/event/add");
  };

  const getDataFromServer = () => {
    let userToken = localStorage.getItem("token");

    let urlLink = `${process.env.REACT_APP_API_URL}/sponsor/${user.church_id}`;

    const config = {
      method: "GET",
      url: urlLink,
      headers: {
        Authorization: `Bearer ${userToken}`,
      },
    };
    axios(config)
      .then(function (response) {
        // Sort the data before setting it
        const sortedData = response.data.sponsorships.sort(
          (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
        );
        setData(sortedData);
      })
      .catch(function (err) {
        console.log("error api call ", err);
      });
  };

  useEffect(() => {
    const getDataFromServer = () => {
      let userToken = localStorage.getItem("token");

      let urlLink = `${process.env.REACT_APP_API_URL}/sponsor/${user.church_id}`;

      const config = {
        method: "GET",
        url: urlLink,
        headers: {
          Authorization: `Bearer ${userToken}`,
        },
      };
      axios(config)
        .then(function (response) {
          // Sort the data before setting it
          const sortedData = response.data.sponsorships.sort(
            (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
          );
          setData(sortedData);
        })
        .catch(function (err) {
          console.log("error api call ", err);
        });
    };
    getDataFromServer();
  }, [addShowModal]);

  const handleDelete = (row) => {
    confirmAlert({
      title: "",
      message: "Are you sure to delete this User ?",
      buttons: [
        {
          label: "Yes",
          onClick: () => deleteRecord(row),
        },
        {
          label: "No",
          //onClick: () => alert('Click No')
        },
      ],
    });
  };

  const deleteRecord = (row) => {
    let userToken = localStorage.getItem("token");
    const config = {
      headers: { Authorization: `Bearer ${userToken}` },
    };
    axios
      .delete(
        `${process.env.REACT_APP_API_URL}/sponsor/delete/${row._id}`,
        config
      )
      .then((response) => {
        //alert(JSON.stringify(response));
        getDataFromServer();
      })
      .catch((err) => {
        errorLogApi(err, "EventListChild", "/events");
      });
  };

  const [searchTerm, setSearchTerm] = useState("");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const filteredData = useMemo(() => {
    return data
      .filter((event) =>
        Object.values(event).some((value) =>
          value.toString().toLowerCase().includes(searchTerm.toLowerCase())
        )
      )
      .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
  }, [data, searchTerm]);

  const paginatedData = useMemo(() => {
    const startIndex = page * rowsPerPage;
    return filteredData.slice(startIndex, startIndex + rowsPerPage);
  }, [filteredData, page, rowsPerPage]);

  return (
    <div className="w-full px-4 mx-auto max-w-7xl sm:px-6 lg:px-8">
      <div className="flex items-center justify-between mb-6">
        <h2 className="text-2xl font-bold text-gray-900">Sponsors List</h2>
        {/* <Button
          variant="contained"
          color="primary"
          startIcon={<FaPlus />}
          onClick={() => {
            toggleAddModal();
            setCurrentRecord({});
          }}
        >
          Add Sponsor
        </Button> */}
      </div>

      <div className="mb-4">
        <TextField
          fullWidth
          variant="outlined"
          placeholder="Search events..."
          InputProps={{
            startAdornment: <FaSearch className="mr-2 text-gray-400" />,
          }}
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
      </div>

      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Action</TableCell>
              <TableCell>Logo</TableCell>
              <TableCell>Sponsor Name</TableCell>
              <TableCell>Event Title</TableCell>
              <TableCell>Amnt</TableCell>
              <TableCell>Contact</TableCell>
              <TableCell>Date</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {paginatedData.map((row) => (
              <TableRow key={row._id}>
                <TableCell>
                  <div className="flex items-center space-x-1">
                    <Tooltip title="View details">
                      <IconButton
                        size="small"
                        onClick={() => {
                          toggleModal();
                          setCurrentRecord(row);
                        }}
                      >
                        <FaEye className="text-blue-600" />
                      </IconButton>
                    </Tooltip>
                    <Tooltip title="Delete">
                      <IconButton
                        size="small"
                        onClick={() => handleDelete(row)}
                      >
                        <FaTrash className="text-red-600" />
                      </IconButton>
                    </Tooltip>
                  </div>
                </TableCell>
                <TableCell>
                  {row.sponsor_logo ? (
                    <img
                      src={`${process.env.REACT_APP_REPORTS_DOWNLOAD_URL}uploads/event/${row.sponsor_logo}`}
                      alt="Sponsor Logo"
                      className="object-cover w-12 h-12 rounded-md"
                      crossOrigin="anonymous"
                    />
                  ) : (
                    <img
                      src={placeholderImage}
                      alt="Placeholder"
                      className="object-cover w-12 h-12"
                    />
                  )}
                </TableCell>
                <TableCell>{row.sponsor_name}</TableCell>
                <TableCell>{row.event_id?.title}</TableCell>
                <TableCell>${row.sponsor_amount}</TableCell>
                <TableCell>
                  <div>
                    <div>{row.sponsor_contact?.name}</div>
                    <div className="text-sm text-gray-500">
                      {row.sponsor_contact?.email}
                    </div>
                  </div>
                </TableCell>
                <TableCell>
                  {dayjs(row.createdAt).format("MMM D, YYYY")}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      {/* Pagination controls */}
      <div className="flex items-center justify-between mt-4">
        <div>
          <span>Rows per page: </span>
          <select
            value={rowsPerPage}
            onChange={(e) => setRowsPerPage(Number(e.target.value))}
          >
            {[5, 10, 25, 50].map((pageSize) => (
              <option key={pageSize} value={pageSize}>
                {pageSize}
              </option>
            ))}
          </select>
        </div>
        <div>
          <Button
            disabled={page === 0}
            onClick={() => setPage((prev) => prev - 1)}
          >
            Previous
          </Button>
          <Button
            disabled={paginatedData.length < rowsPerPage}
            onClick={() => setPage((prev) => prev + 1)}
          >
            Next
          </Button>
        </div>
      </div>

      {/* Modals */}
      <ErrorBoundaryRoutes route="/sponsors" page="ModalView">
        {showModal && (
          <Modal onClose={toggleModal}>
            <SponsorView currentRecord={currentRecord} />
          </Modal>
        )}
        {addShowModal && (
          <Modal onClose={toggleAddModal} dialogClassName="modal-90w">
            <h2 className="mb-4 text-xl font-bold">
              {currentRecord?._id ? "Edit" : "Add"} Event
            </h2>
            <hr />
            {/* <EventAdd
              currentRecord={currentRecord}
              setModel={setAddShowModal}
            /> */}
          </Modal>
        )}
      </ErrorBoundaryRoutes>
    </div>
  );
};

export default SponsorsListChild;
